module.exports = __webpack_public_path__ + "img/check-circle.d790878d.svg";